import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import isEqual from 'lodash/isEqual';
import BASE_CLASSNAMES from '../plugins/constants/baseClassnames';
import { document, window } from '../helpers/BrowserHelpers';
var MARGINS = 8;

var InlineToolbar =
/*#__PURE__*/
function (_Component) {
  _inherits(InlineToolbar, _Component);

  function InlineToolbar() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, InlineToolbar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(InlineToolbar)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      offsetX: 0,
      offsetY: 0
    });

    _defineProperty(_assertThisInitialized(_this), "inputRef", React.createRef());

    _defineProperty(_assertThisInitialized(_this), "getContainerRect", function () {
      var containerId = _this.props.containerId;

      if (containerId && document.getElementById(containerId)) {
        var _document$getElementB = document.getElementById(containerId).getBoundingClientRect(),
            left = _document$getElementB.left,
            top = _document$getElementB.top,
            width = _document$getElementB.width;

        return {
          left: left,
          top: top,
          width: width
        };
      }

      return {
        width: window.innerWidth,
        left: 0,
        top: 0
      };
    });

    _defineProperty(_assertThisInitialized(_this), "setOffset", function () {
      var _this$props$wrapperRe = _this.props.wrapperRect,
          wrapperLeft = _this$props$wrapperRe.left,
          wrapperWidth = _this$props$wrapperRe.width,
          wrapperTop = _this$props$wrapperRe.top,
          wrapperHeight = _this$props$wrapperRe.height;

      var _this$getContainerRec = _this.getContainerRect(),
          containerTop = _this$getContainerRec.top,
          containerLeft = _this$getContainerRec.left,
          containerWidth = _this$getContainerRec.width;

      if (_this.inputRef) {
        var _this$inputRef$curren = _this.inputRef.current.getBoundingClientRect(),
            width = _this$inputRef$curren.width,
            height = _this$inputRef$curren.height;

        var x = wrapperLeft + wrapperWidth / 2 - width / 2 - containerLeft;
        var y = wrapperTop - 4 - height - containerTop;

        _this.setState({
          offsetX: Math.min(0, containerWidth - (width + x)) || Math.max(0, -x),
          offsetY: Math.min(Math.max(0, -y + MARGINS), wrapperHeight)
        });
      }
    });

    return _this;
  }

  _createClass(InlineToolbar, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!isEqual(prevProps.wrapperRect, this.props.wrapperRect)) {
        this.setOffset();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          wrapperRect = _this$props.wrapperRect,
          containerId = _this$props.containerId,
          props = _objectWithoutProperties(_this$props, ["children", "wrapperRect", "containerId"]);

      var _this$state = this.state,
          offsetX = _this$state.offsetX,
          offsetY = _this$state.offsetY;
      return React.createElement("div", Object.assign({
        ref: this.inputRef
      }, props, {
        className: classNames(BASE_CLASSNAMES, 'slite-editor-inline-toolbar background-white color-mode-elevated', props.className),
        style: _objectSpread({
          pointerEvents: 'initial',
          bottom: 4,
          left: '50%',
          transform: "translate(calc(-50% + ".concat(offsetX, "px), ").concat(offsetY, "px)")
        }, props.style)
      }), children);
    }
  }]);

  return InlineToolbar;
}(Component);

_defineProperty(InlineToolbar, "propTypes", {
  children: PropTypes.any,
  wrapperRect: PropTypes.object,
  containerId: PropTypes.string
});

export { InlineToolbar as default };